export const SearchFilterType = {
  STUDENT: 'STUDENT',
  COURSE: 'COURSE',
} as const;
export type SearchFilterType = typeof SearchFilterType[keyof typeof SearchFilterType];
